let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsContainedResult определяет структуру результата логической проверки на включение одного объекта в другой
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsContainedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsContainedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsContainedResult";
  }
}

module.exports = IsContainedResult;